import { render, staticRenderFns } from "./DispenserEdit.vue?vue&type=template&id=a403d2b4"
import script from "./DispenserEdit.vue?vue&type=script&lang=js"
export * from "./DispenserEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports